var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAnnounce(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "16pt",
    height: "16pt",
    viewBox: "0 0 24.000000 24.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,24.000000) scale(0.100000,-0.100000)",
    fill: "#FFFFFF",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104 213 c-13 -22 -14 -25 -2 -15 14 11 20 6 43 -34 22 -37 25 -48 14 -55 -10 -6 -6 -9 13 -9 15 0 29 3 31 8 6 8 -64 132 -74 132 -4 0 -15 -12 -25 -27z m65 -50 c17 -29 27 -53 23 -53 -4 0 -23 28 -41 63 -40 73 -27 66 18 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200 200 c-8 -5 -12 -12 -9 -15 4 -3 12 1 19 10 14 17 11 19 -10 5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 135 c-40 -41 -35 -64 17 -77 18 -5 34 -18 41 -34 7 -14 18 -24 25 -21 12 4 12 12 1 59 -5 20 -2 27 13 32 10 3 2 3 -17 1 -28 -4 -38 -1 -48 16 -10 16 -11 24 -1 35 25 31 1 22 -31 -11z m30 -47 c0 -4 10 -8 23 -8 21 -1 21 -1 3 -11 -13 -8 -20 -8 -25 0 -4 7 -15 9 -24 5 -22 -8 -33 21 -16 42 12 14 14 14 26 -2 7 -10 13 -21 13 -26z m50 -47 c12 -24 13 -31 2 -31 -5 0 -14 11 -20 25 -14 29 2 34 18 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208 163 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnnounce);
export default __webpack_public_path__ + "static/media/announce.e5629a8488c734235b84da433d583fda.svg";
export { ForwardRef as ReactComponent };